import { Switch } from "@/components/ui/switch";
import { useState, useEffect } from "react";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useSelector } from "react-redux";
import CreateCategoryDialog from "@/components/dialog/menu-manage/common-dialog/create-category";
import { ButtonType } from "@/components/lib/Button";

function Step1({ form, course_id }) {
  const [showItem, setShowItem] = useState(false);
  const itemNo = form.watch("item_no");

  useEffect(() => {
   setShowItem(itemNo && itemNo !== null);
  }, [itemNo]);
  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {form.watch("type") == "update" ? "Update Course" : "Add New Course"}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-8">
          <div className="">
            <div className="flex gap-2 items-center">
              <Switch
                checked={showItem}
                onCheckedChange={(val) => {
                  setShowItem(val);
                    if (!val) {
                    form.setValue("item_no", null);
                  }
                }}
              />
              <Label>Item No</Label>
            </div>
            {showItem && (
              <div className="mt-3">
              <FormInputField
                name="item_no"
                style="bg-cblack7"
                placeholder={"Enter item no (must be number)"}
                form={form}
                type="text"
              />
              </div>
            )}
          </div>
          <FormInputField
            name="name"
            style="bg-cblack7"
            placeholder={"Enter Name"}
            form={form}
            type="text"
            label={"Name"}
          />
          <FormInputField
            name="description"
            style="bg-cblack7"
            placeholder={"Enter description"}
            form={form}
            type="text"
            label={"Description"}
          />
        </div>
      </CardContent>
    </Card>
  );
}

export default Step1;
